
































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import DialogBase from '@/components/common/DialogBase.vue';

@Component({
  components: {
    DialogBase,
  },
})
export default class SimpleDialog extends Vue {
  /** props */
  @Prop() private modal!: boolean;
  @Prop() private dialogText!: string;
  @Prop() private dialogSubText!: string;
  @Prop() private mainButtonText!: string;
  @Prop() private subButtonText!: string;
  @Prop({
    type: String,
    default: 'txt-ja-style-4 padding-w32 pb-0 text-center indentionStyle',
  })
  dialogTextStyle?: string;

  /** emit */
  @Emit('click-main')
  clickMain() {
    return;
  }
  @Emit('click-sub')
  clickSub() {
    return;
  }
  @Emit('close-dialog')
  closeDialog() {
    return;
  }
  /** computed */
  get existsSubButton(): boolean {
    if (this.subButtonText != null) {
      return true;
    }
    return false;
  }
  get existsSubText(): boolean {
    if (this.dialogSubText != null) {
      return true;
    }
    return false;
  }
}
